module.exports = __webpack_public_path__ + "static/media/dash.5529e956.svg";